<div class="activities-content">
    <div class="activities-header">
        <div class="activities-headline">Activity Log</div>
        @if (nextReview$ | async; as nextReview) {
            <div class="activities-next">
                <div class="font-bold mr-1">Next Review:</div>
                @if ((nextReview | unixTimeToDaysFromNow) >= 1) {
                    <div class="no-wrap vertical-center">
                        in {{ nextReview | unixTimeToDaysFromNow }} {{ (nextReview | unixTimeToDaysFromNow) === 1 ? 'day' : 'days' }}
                    </div>
                }
                @if ((nextReview | unixTimeToDaysFromNow) < 1) {
                    <div class="no-wrap vertical-center">overdue</div>
                }
            </div>
        }
    </div>
    @for (activity of siteActivities$ | async; track activity) {
        <div class="activity-card">
            <div class="activity-header" [ngClass]="{ 'with-content': activity.content !== '' }">
                <div class="activity-header-left">
                    <div class="activity-icon">
                        <mat-icon fontSet="material-icons-outlined">{{ getTypeIcon(activity.type) }}</mat-icon>
                    </div>
                    <div class="activity-info">
                        <div class="activity-type">{{ activity.createdAt | unixTimeToDate: 'MMMM D, YYYY' }} - {{ getTypeName(activity.type) }}</div>
                        <div class="activity-details">{{ activity.author }}</div>
                    </div>
                </div>
                <div class="activity-header-right">
                    @if (activity.link) {
                        <div (click)="openLink(activity.link.url)" class="activity-link">
                            <mat-icon class="activity-link-icon" fontSet="material-icons-outlined">link</mat-icon>{{ activity.link.name }}
                        </div>
                    }
                </div>
            </div>
            @if (activity.content) {
                <div
                    class="activity-content"
                    class="prose prose-sm max-w-none"
                    [innerHtml]="activity.content | debug | replaceString: emptyParagraphsRegexp : ''"
                ></div>
            }
        </div>
    }
</div>
